import { z } from "zod";

export const offerConditionSchema = z.enum(["new", "used"]);
export type OfferCondition = z.output<typeof offerConditionSchema>;
export type OfferSummaryByCondition<T> = { newOffer: T | null; usedOffer: T | null };
